import { Controller } from "@hotwired/stimulus"

// EPIC-044: SPA-style route-in announcement. Move focus to the page <h1>
// (tabindex=-1) on connect so a screen-reader hears the location name when the
// detail page loads — Turbo Drive does not announce route changes natively.
export default class extends Controller {
  connect() {
    this.element.focus({ preventScroll: true })
  }
}
